export default __webpack_public_path__ + "static/media/DigitalMarketingServices360DevPro.47e52bb3.png";